<template>
  <div class="page">
    <span>共{{total}}篇文章</span>
    <span>{{curPage}}/{{page}}页</span>
    <a href="javascript:void(0);" v-show="showFirstPage" @click="firstPage">首页</a>
    <a href="javascript:void(0);" v-show="showPrevPage" @click="prevPage">上一页</a>
    <a href="javascript:void(0);" v-show="showNextPage" @click="nextPage">下一页</a>
    <a href="javascript:void(0);" v-show="showLastPage" @click="lastPage">尾页</a>
  </div>
</template>
<script>
export default {
  name: "page",
  data() {
    return {
      showFirstPage: true,
      showLastPage: true,
      showPrevPage: true,
      showNextPage: true
    };
  },
  watch: {
    curPage(){
      this.initPager();
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initPager();
    });
  },
  methods: {
    nextPage() {
      //下一页
      this.$emit("setPage", this.curPage + 1); //调用父组件方法
    },
    prevPage() {
      //上一页
      this.$emit("setPage", this.curPage - 1); //调用父组件方法
    },
    firstPage() {
      this.$emit("setPage", 1); //调用父组件方法
    },
    lastPage() {
      this.$emit("setPage", this.page); //调用父组件方法
    },
    initPager() {
      this.showFirstPage = this.curPage > 1;
      this.showLastPage = this.curPage < this.page;
      this.showPrevPage = this.curPage > 1;
      this.showNextPage = this.curPage < this.page;
    }
  },
  props: ["curPage", "page", "total", "pageSize"]
};
</script>
<style scoped>
.page {
  text-align: center;
  margin: 80px 0 20px;
  color: #666;
  font-size: 18px;
}
.page > a,
.page > span {
  margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/paging/page.vue